<template>
  <sweet-modal title="Bank Account Info" blocking ref="modal" class="modal" v-on:close="close" width="700">
    <el-form :model="form" size="mini" ref="form" status-icon :rules="rules" label-position="left" label-width="200px">
      <el-tabs v-model="activeTab">
        <el-tab-pane name="first" label="Account">
          <el-form-item label="Account display name" prop="name">
            <div>
              {{form.name}}
            </div>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="Tax Code" prop="taxCode">
            <div>{{form.taxCode}}</div>
          </el-form-item>
          <el-form-item label="Account Currency" prop="accountCurrency">
            <div>
              {{form.accountCurrency}}
            </div>
          </el-form-item>
          <el-form-item label="Opening Balance" prop="openingBalance">
            <div style="display: flex; align-items: center;">
              <div>
                {{formatPrice(form.openingBalance)}}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="Current Balance" prop="currentBalance">
            <div style="display: flex; align-items: center;">
              <div>
                {{formatPrice(form.currentBalance)}}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="Overdraft Limit" prop="overdraftLimit">
            <div style="display: flex; align-items: center;">
              <div>
                {{formatPrice(form.overdraftLimit)}}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="Allow Balancing Transactions" prop="allowBalancingTransaction">
            <el-checkbox disabled v-model="form.allowBalancingTransaction"></el-checkbox>
          </el-form-item>
          <el-form-item label="Account Status" prop="accountStatus">
            <el-checkbox-group disabled v-model="form.accountStatus">
              <el-checkbox label="Inactive"></el-checkbox>
              <el-checkbox label="Closed"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane name="second" label="Financial Institution">
          <el-card>
            <el-form-item label="Financial Institution" prop="financialInstitution">
              <div>{{form.financialInstitution}}</div>
            </el-form-item>
            <el-form-item label="Website" prop="website">
              <div><a :href="form.website" target="_blank">{{form.website}}</a></div>
            </el-form-item>
            <el-form-item label="Bank Account Type" prop="bankAccountType">
              <div>{{bankAccountTypeList.find(val => val.id === form.bankAccountType) ? bankAccountTypeList.find(val => val.id === form.bankAccountType).name : null }}</div>
            </el-form-item>
            <el-form-item label="Bank Swift Code" prop="bankSwiftCode">
              <div>{{form.bankSwiftCode}}</div>
            </el-form-item>
            <el-form-item label="Bank Code" prop="bankCode">
              <div>{{form.bankCode}}</div>
            </el-form-item>
            <el-form-item label="Account Number" prop="accountNumber">
              <div>{{form.accountNumber}}</div>
            </el-form-item>
            <el-form-item label="IBAN" prop="IBAN">
              <div>{{form.IBAN}}</div>
            </el-form-item>
            <h3>Bank Manager</h3>
            <el-form-item label="Name" prop="bankManagerName">
              <el-row :span="24" :gutter="20" style="display: flex;">
                <el-col :span="12">
                  <div>{{form.bankManagerName}}</div>
                </el-col>
                <el-col :span="12">
                  <div>{{form.managerLastName}}</div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Email" prop="bankManagerEmail">
              <div>{{form.bankManagerEmail}}</div>
            </el-form-item>
            <el-form-item label="Phone" prop="bankManagerPhone">
              <div>{{form.bankManagerPhone}}</div>
            </el-form-item>
            <el-form-item label="Fax" prop="BankManagerFax">
              <div>{{form.BankManagerFax}}</div>
            </el-form-item>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="third" label="Reconciliation">
          <el-form-item label="Reconcillation" prop="reconciliationDays">
            <el-row :span="24" :gutter="20" style="display: flex;">
              <el-col :span="12">
                <div>{{form.reconciliationDays}}</div>
              </el-col>
              <el-col :span="12">
                <el-date-picker
                    readonly
                    v-model="form.reconcillationStartDate"
                    format="d MMM yy"
                    value-format="timestamp"
                    type="date"
                    placeholder="Start Date">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Business Unit" prop="reconciliationDays">
            {{buList.find(val => val.id === form.buId) ? buList.find(val => val.id === form.buId).name : ''}}
          </el-form-item>
          <el-form-item label="User" prop="reconciliationDays">
            {{userName ? userName.companyUser.user.fullName : ''}}
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import { Money, VMoney } from 'v-money'
import axios from 'axios';
import moment from 'moment'

export default {
  name: "settingsBankAccountInfoModal",
  components: {
    SweetModal,
    Money
  },
  directives: {money: VMoney},
  computed: {
    userName() {
      return this.userList.find(val => val.companyUser.userId === this.form.buUserId)
    }
  },
  data() {
    return {
      form: {
        // TODO added
        id: null,
        currentBalance: 0,
        overdraftLimit: 0,
        reconciliationDays: null,
        reconcillationStartDate: null,
        allowBalancingTransaction: false,
        financialInstitution: null,
        website: null,
        bankSwiftCode: null,
        IBAN: null,
        bankCode: null,
        accountNumber: null,
        bankManagerName: null,
        bankManagerEmail: null,
        bankManagerPhone: null,
        BankManagerFax: null,
        buId: null,
        buUserId: null,
        name: null,
        taxCode: null,
        accountCurrency: null,
        openingBalance: 0,
        accountStatus: [],
        bankAccountType: null,
        managerLastName: null,
      },
      rules: {
        // financialInstitution: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // bankSwiftCode: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // IBAN: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // bankCode: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // accountNumber: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ]
      },
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      userList: [],
      buList: [],
      activeTab: 'first',
      moment: moment,
      bankAccountTypeList: []
    }
  },
  methods: {
    async openModal(row) {
      console.log('--row--', row)
      let loader = this.$loading.show();
      this.form.name = row.name
      this.form.id = row.id
      this.form.accountCurrency = row.currencyName
      this.form.currentBalance = row.bankAccount.currentBalance
      this.form.overDraftLimit = row.bankAccount.overDraftLimit
      this.form.reconciliationDays = row.bankAccount.reconciliationDays
      this.form.reconcillationStartDate = row.bankAccount.reconciliationStartDate ? moment(row.bankAccount.reconciliationStartDate).format('x') : null
      this.form.allowBalancingTransaction = row.bankAccount.allowBalancingTransaction
      this.form.financialInstitution = row.bankAccount.financialInstitution
      this.form.website = row.bankAccount.website
      this.form.bankAccountType = row.bankAccount.bankAccountTypeID
      this.form.bankSwiftCode = row.bankAccount.bankSwiftCode
      this.form.bankCode = row.bankAccount.bankCode
      this.form.accountNumber = row.bankAccount.accountNumber
      this.form.IBAN = row.bankAccount.IBAN
      this.form.bankManagerName = row.bankAccount.bankManagerName
      this.form.bankManagerEmail = row.bankAccount.bankManagerEmail
      this.form.bankManagerPhone = row.bankAccount.bankManagerPhone
      this.form.BankManagerFax = row.bankAccount.BankManagerFax
      this.form.buId = row.bankAccount.buId
      this.form.buUserId = row.bankAccount.buUserId
      const response = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
      if (this.form.buUserId) {
        const response2 = await axios.post(`/api/v1/businessUnitUsers/list?companyId=${this.$route.query.companyId}&businessUnitId=${this.form.buId}`)
        this.userList = response2.data.list
      }
      const bakAccountTypes = await axios.get(`/api/v1/bankAccountType/list?companyId=${this.$route.query.companyId}`)
      this.bankAccountTypeList = bakAccountTypes.data.list
      this.buList = response.data.list
      loader.hide()
      // TODO what to set here
      this.$refs.modal.open()
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    close() {
      this.form.id = null
      this.form.name = ''
      this.form.taxCode = null
      this.form.accountCurrency = null
      this.form.openingBalance = 0
      this.form.currentBalance = 0
      this.form.reconciliationDays = null
      this.form.reconcillationStartDate = null
      this.form.allowBalancingTransaction = false
      this.form.accountStatus = []
      this.form.financialInstitution = null
      this.form.website = null
      this.form.bankAccountType = null
      this.form.bankSwiftCode = null
      this.form.bankCode = null
      this.form.accountNumber = null
      this.form.IBAN = null
      this.form.bankManagerName = null
      this.form.managerLastName = null
      this.form.bankManagerEmail = null
      this.form.bankManagerPhone = null
      this.form.BankManagerFax = null
      this.form.buId = null
      this.form.buUserId = null
      this.activeTab = 'first'
      this.userList = []
      this.buList = []
      this.bankAccountTypeList = []
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.amount-input {
  display: block;
  resize: vertical;
  padding: 0 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
  &.readonly {
    background: rgba(201, 202, 205, 0.5);
  }
}
</style>
